import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FormattedMessage, FormattedDate } from 'react-intl'
import { Row, Col } from 'react-flexbox-grid'
import Loader from 'components/util/Loader'
import moment from 'moment'
import styles from './_personalGoalsPage.css'
import * as goalActions from 'services/goals/actions'
import * as goals from 'services/goals/selectors'
import { selectShouldSeeAds } from 'services/premium/selectors'
import ActiveGoal from './ActiveGoal'
import { USER_GOAL_SUGGESTIONS } from '../shared/constants'
import SuggestedGoal from './SuggestedGoal'
import GoalsHeader from '../shared/GoalsHeader'
import { AD_SIZES } from 'services/ads/constants'
import Ad from 'components/util/ads/Ad'

const mapStateToProps = (state) => ({
  userGoals: goals.selectUserGoals(state),
  viewGoalsLoading: goals.selectViewGoalsLoading(state),
  noGoalsFound: goals.selectNoGoalsFound(state),
  shouldSeeAds: selectShouldSeeAds(state),
})

const mapDispatchToActions = {
  ...goalActions,
}

export class PersonalGoalsPage extends Component {
  static propTypes = {
    shouldSeeAds: PropTypes.bool,
    params: PropTypes.object,
    userGoals: PropTypes.array,
    loadViewGoalsPage: PropTypes.func,
    viewGoalsLoading: PropTypes.bool,
    noGoalsFound: PropTypes.bool,
    stopGoal: PropTypes.func,
  }

  componentWillMount () {
    const { params: { userId }} = this.props
    this.props.loadViewGoalsPage(userId)
  }

  handleStopGoal = (goalId) => {
    this.props.stopGoal(goalId)
  }

  render () {
    const {
      userGoals,
      noGoalsFound,
      params: {
        userId,
      },
      viewGoalsLoading,
      shouldSeeAds,
    } = this.props

    const weekStart = moment().startOf('week').toDate()
    const weekEnd = moment().endOf('week').toDate()
    const remaining = moment().endOf('week').diff(moment(), 'days')

    return (
      <Row>
        <Col xs={12} md={shouldSeeAds ? 8 : 12}>
          <div className={styles.personalGoalsPage}>
            <GoalsHeader userId={userId} />
            <div className={styles.activeGoalsContainer}>
              <div className={styles.sectionHeaderContainer}>
                <h3 className={styles.sectionHeader}>
                  <FormattedMessage
                    id='goals.header.active'
                    defaultMessage='Active Goals' />
                </h3>
              </div>
              <Row className={styles.dateContainer}>
                <Col xs={6}>
                  <div className={styles.daysLeft}>
                    <div className={styles.daysRemaining}>
                      <FormattedMessage
                        id='goals.daysremaining'
                        defaultMessage='{numOfDays} {numOfDays, plural, one {day} other {days}} left for week'
                        values={{
                          numOfDays: remaining,
                        }} />
                    </div>
                  </div>
                </Col>
                <Col xs={6} className={styles.dateRange}>
                  <FormattedDate value={weekStart} /> - <FormattedDate value={weekEnd} />
                </Col>
              </Row>
              {noGoalsFound ?
                <div className={styles.noGoalsFound}>
                  <FormattedMessage
                    id='goals.nonefound'
                    defaultMessage='There are no active goals.' />
                </div> : null}

              {!viewGoalsLoading ?
                <div>
                  {userGoals.map((goal, i) => {
                    return (
                      <ActiveGoal
                        key={i}
                        goal={goal}
                        stopGoalAction={(goalId) => this.handleStopGoal(goalId)} />
                    )
                  })}
                </div>
              :
                <div className={styles.pageLoader}>
                  <Loader type='spin' height={60} width={60} />
                </div>}
            </div>
            <div className={styles.suggestedGoalsContainer}>
              <div className={styles.sectionHeaderContainer}>
                <h3 className={styles.sectionHeader}>
                  <FormattedMessage
                    id='goals.header.suggested'
                    defaultMessage='Suggested Goals' />
                </h3>
              </div>
              {USER_GOAL_SUGGESTIONS.map((suggGoal, idx) => {
                return <SuggestedGoal userId={userId} goal={suggGoal} key={idx} />
              })}
            </div>
          </div>
        </Col>
        <Col xs={12} md={4}>
          <Ad sizes={[AD_SIZES.RAIL_3]} />
        </Col>
      </Row>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(PersonalGoalsPage)



// WEBPACK FOOTER //
// ./src/components/goals/view/PersonalGoalsPage.jsx